module.exports = __webpack_public_path__ + "static/media/12.3df3e466.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/12.svg
// module id = 2803
// module chunks = 3